export default {
  form: {
    agreement: {
      label:
        'Vahvistan, että sähköisen hyväksyntäni antaminen vastaa tämän asiakirjan allekirjoittamista, ja ymmärrän, että sähköinen allekirjoitukseni on sitova.',
    },
    signed_by: {
      label: 'Nimi',
      placeholder: 'Nimi',
    },
    signer_first_name: {
      label: 'Etunimi',
      placeholder: 'Etunimi',
    },
    signer_last_name: {
      label: 'Sukunimi',
      placeholder: 'Sukunimi',
    },
    recipient_email: {
      label: 'Vastaanottajan sähköpostiosoite',
      placeholder: 'Syötä sähköpostiosoite',
    },
    send_to_email: {
      label: 'Lähetä sopimus omistajalle sähköpostitse ({{email}})',
    },
    additional_locations: {
      label: 'Lisätoimipisteet',
      placeholder: 'Hae lisättävää toimipistettä',
    },
    special_agreements: {
      label: 'Erityissopimukset',
      placeholder: 'Syötä mahdolliset erityissopimukset',
    },
  },
  labels: {
    name: 'Nimi',
    date: 'Päivämäärä',
  },
  buttons: {
    sign_in_person: 'Allekirjoita täällä omistajan kanssa',
    back: 'Takaisin',
    edit_contract: 'Muokkaa sopimusta',
    skip: 'Ohita',
    sign: 'Allekirjoita',
    init_sign: 'Luo sopimus ja lähetä',
    redo: 'Tee uudelleen',
    continue: 'Jatka',
    preview: 'Esikatselu',
    submit: 'Lähetä',
  },
  toasts: {
    failed_to_preview_contract: 'Sopimuksen esikatselu epäonnistui',
    contract_signing_pending: 'Hetkinen, käynnistämme sopimustasi...',
    failed_to_sign_contract: 'Sopimuksen käynnistäminen epäonnistui ⁉️',
    contract_got_signed: 'Sopimus käynnistetty 👌',
  },
  in_person_signing: {
    description:
      'Omistaja on saanut tämän linkin sähköpostitse ja voi allekirjoittaa etänä. Jos omistaja on nyt luonasi, avaa allekirjoitussivu täältä.',
  },
  signature_link: {
    label: 'Allekirjoituslinkki (sama linkki lähetetty vastaanottajalle sähköpostitse)',
    copy: 'Kopioi',
    copied: 'Allekirjoituslinkki kopioitu leikepöydälle',
  },
  header: 'Luo sopimus',
  description: 'Tarkista sopimuksen tiedot ja syötä sähköpostiosoite, johon sopimus lähetetään.',
};
